import { InputHTMLAttributes } from 'react';
import InputMask from 'react-input-mask-next';
import { Container } from '../styles';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  label: string;
  size?: number;
  value: string;
  isError: boolean;
}

export const InputTelefoneMask = ({
  name,
  size,
  label,
  isError,
  ...rest
}: InputProps) => {
  return (
    <Container error={isError}>
      <label htmlFor={name}>{label}</label>
      <InputMask
        mask="(99) 99999-9999"
        name={name}
        style={{ width: size }}
        {...rest}
      />
    </Container>
  );
};
